import { msalInstance } from '../auth/msalInstance'
import { graphRequest } from '../auth/msalConfig'

export interface EntraUser {
  id: string
  displayName: string
  givenName: string
  surname: string
  mail: string | null
  userPrincipalName: string
}

export async function searchEntraUsers(query: string): Promise<EntraUser[]> {
  if (!query || query.length < 2) return []

  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) return []

  const tokenResponse = await msalInstance.acquireTokenSilent({
    ...graphRequest,
    account: accounts[0],
  })

  const search = encodeURIComponent(`"displayName:${query}" OR "mail:${query}"`)
  const url = `https://graph.microsoft.com/v1.0/users?$search=${search}&$select=id,displayName,givenName,surname,mail,userPrincipalName&$top=10&$count=true`

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${tokenResponse.accessToken}`,
      ConsistencyLevel: 'eventual',
    },
  })

  if (!res.ok) return []
  const data = await res.json()
  return (data.value ?? []) as EntraUser[]
}

async function getGraphToken(): Promise<string | null> {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) return null
  const tokenResponse = await msalInstance.acquireTokenSilent({
    ...graphRequest,
    account: accounts[0],
  })
  return tokenResponse.accessToken
}

export async function getEntraUserPhoto(userId: string): Promise<string | null> {
  const token = await getGraphToken()
  if (!token) return null

  try {
    const res = await fetch(
      `https://graph.microsoft.com/v1.0/users/${userId}/photos/96x96/$value`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    if (!res.ok) return null
    const blob = await res.blob()
    return URL.createObjectURL(blob)
  } catch {
    return null
  }
}

export async function getEntraUserManager(userId: string): Promise<EntraUser | null> {
  const token = await getGraphToken()
  if (!token) return null

  const url = `https://graph.microsoft.com/v1.0/users/${userId}/manager?$select=id,displayName,givenName,surname,mail,userPrincipalName`
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  })

  if (!res.ok) return null
  return await res.json() as EntraUser
}
